import React from 'react';
import isEmpty from 'lodash/isEmpty';
import OfficeBuildingFilledIcon from '@atlaskit/icon/glyph/office-building-filled';
import GlobeIcon from '@atlaskit/icon/core/globe';
import { Checkbox } from '@atlaskit/checkbox';
import { Stack } from '@atlaskit/primitives';
import Lozenge from '@atlaskit/lozenge';
import { NEW_CLOUD_SITE } from '../../constants/cart-table';

export const getCloudSiteOrgRow = ({
  totalColumns,
  orgName,
  cloudSiteName,
  isChecked,
  onCheckboxToggle,
  addButtonComponent,
  isLineItemEditEnabled = true,
}: {
  totalColumns: number;
  orgName?: string;
  cloudSiteName?: string;
  isChecked?: boolean;
  onCheckboxToggle?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  addButtonComponent?: React.ReactNode;
  isLineItemEditEnabled?: boolean;
}) => {
  const emptyArray = Array.from({ length: totalColumns });
  const isOrgNamePresent = !isEmpty(orgName);
  const isSiteNamePresent = !isEmpty(cloudSiteName);

  const cloudSiteOrOrgNode = (() => {
    const NewCloudSiteLozenge = () => (
      <Lozenge testId="new-cloud-site" appearance={'new'}>
        {NEW_CLOUD_SITE}
      </Lozenge>
    );

    const orgNode = (
      <>
        <OfficeBuildingFilledIcon primaryColor="var(--ds-icon-accent-gray)" label="" /> <Stack>{orgName}</Stack>
      </>
    );
    const newSiteNode = (
      <>
        <GlobeIcon color="var(--ds-icon-accent-gray)" label="cloud-site-icon" />
        <NewCloudSiteLozenge />
      </>
    );
    const siteNode = (
      <>
        <GlobeIcon color="var(--ds-icon-accent-gray)" label="cloud-site-icon" />
        <Stack>{cloudSiteName}</Stack>
      </>
    );

    return isOrgNamePresent ? orgNode : isSiteNamePresent ? siteNode : newSiteNode;
  })();

  return [
    emptyArray.map((_, index) => {
      if (index === 0 && isLineItemEditEnabled) {
        return (
          <td key={`checkbox-cell-select-all`}>
            <Checkbox
              isChecked={isChecked}
              testId={`select-product-checkbox-${orgName || cloudSiteName}`}
              onChange={onCheckboxToggle}
              label=""
            />
          </td>
        );
      }
      if ((index === 1 && isLineItemEditEnabled) || (index === 0 && !isLineItemEditEnabled)) {
        return (
          <td
            title={isOrgNamePresent ? orgName : cloudSiteName}
            className="col-cloud-site-name"
            key={`cloud-site-cell-product-name}`}
          >
            {cloudSiteOrOrgNode}
          </td>
        );
      }
      if (totalColumns - 1 === index && isLineItemEditEnabled) {
        return (
          <td className={'col-product-add-new'} key={`cloud-site-cell-add-new-add`}>
            {addButtonComponent}
          </td>
        );
      }
      return <td className="cloud-site-empty-cell" key={`cloud-site-cell-${index}`} />;
    }),
  ];
};
